import { ActionRowBuilder, EmbedBuilder } from "discord.js";
import { IMultiPageEmbedData, IMultiPageEmbed } from "../typings";
import { ButtonBuilder } from "../builders";

export class MultiPageEmbed implements IMultiPageEmbed {
    private _id: string;
    private _userId?: string;
    private _expires: number;
    private _startingPage: number;
    private _embeds: EmbedBuilder[];
    private _canLoop: boolean;
    private _jump: boolean;

    get id() {
        return this._id;
    }

    get userId() {
        return this._userId;
    }

    get expires() {
        return this._expires;
    }

    get startingPage() {
        return this._startingPage;
    }

    get embeds() {
        return this._embeds;
    }

    get canLoop() {
        return this._canLoop;
    }

    get jump() {
        return this._jump;
    }

    constructor(data: IMultiPageEmbedData) {
        this._id = data.id!;
        this._expires = data.expires ?? 120000;
        this._startingPage = data.startingPage ?? 0;
        this._embeds = data.embeds ?? [];
        this._canLoop = data.canLoop ?? true;
        this._jump = data.jump ?? false;
    }

    get components() {
        const row = new ActionRowBuilder<ButtonBuilder>()
        if (this.jump) row.addComponents(
            new ButtonBuilder()
            .setCustomId("multipageembed")
            .setUserId(this.userId)
            .setArguments("jump-start", this.id)
            .setEmoji("⏮️")
            .setStyle("gray")
            .setDisabled(this.startingPage === 0)
        )
        row.addComponents(
            new ButtonBuilder()
            .setCustomId("multipageembed")
            .setUserId(this.userId)
            .setArguments("previous", this.id)
            .setEmoji("⏪")
            .setStyle("gray")
            .setDisabled(this.startingPage === 0 && !this.canLoop),
            new ButtonBuilder()
            .setCustomId("multipageembed")
            .setUserId(this.userId)
            .setArguments("next", this.id)
            .setEmoji("⏩")
            .setStyle("gray")
            .setDisabled(this.startingPage === this.embeds.length - 1 && !this.canLoop)
        )
        if (this.jump) row.addComponents(
            new ButtonBuilder()
            .setCustomId("multipageembed")
            .setUserId(this.userId)
            .setArguments("jump-end", this.id)
            .setEmoji("⏭️")
            .setStyle("gray")
            .setDisabled(this.startingPage === this.embeds.length - 1)
        )
        return [row];
    }

    get page() {
        return this.embeds[this.startingPage];
    }
}